import MEDIA_SERVERS from "constants/MEDIA_SERVERS"
import map from "rfuncs/functions/map"

export default path => map(prefix => `${prefix}${path || ""}`, MEDIA_SERVERS)
